import { Ord as OrdS } from 'fp-ts/lib/string';
import { Ord as OrdB } from 'fp-ts/lib/boolean';
import { pipe } from 'fp-ts/lib/function';
import { contramap } from 'fp-ts/lib/Ord';
import { getDefaultCountry } from './countries';

type SelectFn<A, B> = (item: A) => B;

export const promotedCountries = ['DK', 'SE', 'DE'];

export const byPromotedCountries = <T>(fn: SelectFn<T, string>) =>
  pipe(
    OrdB,
    contramap((item: T) => !promotedCountries.includes(fn(item) || ''))
  );

export const byCountryLocale =
  <T>(fn: SelectFn<T, string>) =>
  (locale: string) =>
    pipe(
      OrdB,
      contramap((item: T) => fn(item) !== getDefaultCountry(locale))
    );

export const byString = <T>(fn: SelectFn<T, string>) =>
  pipe(OrdS, contramap(fn));
